import { v4 } from 'uuid';
import { Entity } from '../../../../common/ddd/entity.base';
import {
  AccountMetricInsightsMetricType,
  MetricValueType,
} from '../../../../interface/dtos';

export interface ChallengeSentimentEntityProps {
  value: number;
  count: number;
  date?: Date;
  uniqueUsers?: number;
  userId?: string;
  userCount?: number;
  type?: MetricValueType;
}

export class ChallengeSentimentEntity extends Entity<ChallengeSentimentEntityProps> {
  protected _id: string;

  static create(
    props: ChallengeSentimentEntityProps,
    entityId?: string
  ): ChallengeSentimentEntity {
    const id = entityId || v4();
    const entity = new ChallengeSentimentEntity({
      id,
      props,
    });
    return entity;
  }

  public validate() {}

  get count() {
    return this.props.count;
  }

  get value() {
    return this.props.value;
  }

  get userId() {
    return this.props.userId;
  }
  get metricType() {
    return AccountMetricInsightsMetricType.Sentiment;
  }

  get date() {
    const d = new Date(this.props.date);
    return isNaN(d.getTime()) ? null : d;
  }

  setUserId(userId: string): void {
    this.props.userId = userId;
  }

  get avg() {
    return this.count > 0 ? this.value / this.count : this.value;
  }

  get uniqueUsers(): number {
    return this.props.uniqueUsers || 0;
  }

  get userCount() {
    return this.props.userCount || 0;
  }

  get type() {
    return this.props.type;
  }

  set type(type: MetricValueType) {
    this.props.type = type;
  }
}
